module.exports = __webpack_public_path__ + "static/media/Video Player 2.c0336cfa.svg";